function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 9,
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.30467 4H5V14H9.69779C10.7002 14 11.5061 13.7331 12.0958 13.1786C12.6855 12.6448 13 11.9261 13 11.0431C13 10.345 12.7445 9.77002 12.2531 9.27721L11.172 10.0164C11.4275 10.3039 11.5651 10.6324 11.5651 11.0021C11.5651 11.4949 11.3882 11.885 11.0344 12.1725C10.6806 12.46 10.1892 12.6037 9.5602 12.6037H6.51351V5.41684H9.22604C10.3268 5.41684 10.8968 5.86858 10.8968 6.73101C10.8968 7.6345 10.3268 8.08624 9.22604 8.08624H7.47666V9.48255H9.30467C10.2088 9.48255 10.9558 9.23614 11.5061 8.70226C12.0565 8.18891 12.3514 7.51129 12.3514 6.64887C12.3514 5.82752 12.0762 5.17043 11.5258 4.69815C10.9754 4.24641 10.2285 4 9.30467 4Z",
  fill: "#5F37FF"
});

var SvgBcoinWhite = function SvgBcoinWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBcoinWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bcoinWhite.76daceca.svg";
export { ForwardRef as ReactComponent };